import "./style.scss";
import { useState } from "react";
import CONTENT from "./content";

function FAQ() {
    const [activeQuestions, setActiveQuestions] = useState([]);
    const [questionHeights, setQuestionHeights] = useState({});

    const isOpen = (id) => activeQuestions.includes(id);
    const getMaxHeight = (id) => (questionHeights[id] ? `${questionHeights[id]}px` : "0px");

    const onQuestionClick = (e, id) => {
        if (e.target.nodeName === "A") return;

        const li = e.currentTarget;
        const panel = li.querySelector(".faq-section--item--answer");
        if (panel && !questionHeights[id]) {
            const full = panel.scrollHeight;
            setQuestionHeights((prev) => ({ ...prev, [id]: full }));
        }

        setActiveQuestions((prev) =>
            prev.includes(id) ? prev.filter((qid) => qid !== id) : [...prev, id]
        );
    };

    const stringAsHtml = (string) => ({ __html: string });

    return (
        <div className="l-container">
            <div className="info">
                <h2>Vanliga frågor och svar</h2>
                <p>Här hittar du svaren på våra vanligaste frågor.</p>
            </div>
            <ul className="l-list">
                {CONTENT.map((q) => (
                    <li
                        key={q.id}
                        className={
                            isOpen(q.id)
                                ? "faq-section--item faq-section--item__active"
                                : "faq-section--item"
                        }
                        onClick={(e) => onQuestionClick(e, q.id)}
                    >

                        <div className="c-listcard__title">{q.question}</div>

                        <div
                            className="faq-section--item--answer"
                            dangerouslySetInnerHTML={stringAsHtml(q.answer)}
                            style={{ maxHeight: isOpen(q.id) ? getMaxHeight(q.id) : "0px" }}
                        />
                        <div className="faq-section--toggle">
                            <i className="fa fa-chevron-down" aria-hidden="true" />
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default FAQ;
